//#region types
import { MoreActionMenuItem } from "models/propTypes/menuPropTypes";
import { TranslationKeys } from "translations";
import { IconDefinitionConstants } from "utils/constants";
import { WintSuperkollAPIModel as ApiModel } from "wint-api-client/dist/types";
//#endregion
//#region components
import useInvoicePreview from "../usePreview";
import useInvoiceDownload from "./useDownload";
import { useInvoiceService } from "serviceHooks";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

function useInvoiceSendMoreActions(invoice: ApiModel.Invoice, reloadHandler?: () => void) {
  const invoiceService = useInvoiceService();
  const onDownloadClick = useInvoiceDownload(invoice.id ?? 0);

  const downloadAction = (version?: number): MoreActionMenuItem => ({
    description: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Invoice.Download),
    icon: IconDefinitionConstants.WDownload,
    onClickHandler: () => onDownloadClick(version),
  });

  const { getSentInvoicePreviewDialog: getPreviewDialog } = useInvoicePreview();

  const emailInvoiceAdvancedAction = (version?: number, overrideTotalAmount?: number): MoreActionMenuItem => ({
    description: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Invoice.Mail),
    icon: IconDefinitionConstants.WPaperPlane,
    actionDialog: getPreviewDialog(
      invoice,
      undefined,
      reloadHandler,
      ApiModel.InvoiceSendMethod.Email,
      version,
      overrideTotalAmount
    ),
  });

  const printInvoiceAction: MoreActionMenuItem | undefined =
    invoice.status !== ApiModel.InvoiceStatus.Collection &&
    invoice.canSendLastVersionToPagero &&
    invoice.invoiceSource !== ApiModel.InvoiceSource.SelfInvoice
      ? {
          description: invoiceService.getSendAsTypeText(ApiModel.InvoiceSendMethod.Print),
          icon: IconDefinitionConstants.WEnvelop,
          actionDialog: getPreviewDialog(invoice, undefined, reloadHandler, ApiModel.InvoiceSendMethod.Print),
        }
      : undefined;

  return { downloadAction, emailInvoiceAdvancedAction, printInvoiceAction };
}

export default useInvoiceSendMoreActions;
